// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__CEDbP","cardTitle":"ActiveCustomers_cardTitle__ymZCc","chart":"ActiveCustomers_chart__BOWCL"};